import { useTranslation } from 'react-i18next'

import {
  ProductPreviewPricedCataloguedProductFragment,
  ProductPreviewProductFragment,
} from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { ImageItem } from '@/modules/shared/components/image/ImageItem'
import { ProductItem } from '@/modules/shared/components/table/table-column-items/shared/ProductItem'
import { useMoney } from '@/modules/shared/hooks/useMoney'

interface ProductPreviewProps {
  product: ProductPreviewProductFragment | null
  pricedCataloguedProduct?: ProductPreviewPricedCataloguedProductFragment | null
}

export default function ProductPreview({ product, pricedCataloguedProduct }: ProductPreviewProps) {
  const { brand, itemDescription, category, image: productImage } = product || {}
  const { sellUnitPrice, sellUnitTaxPercentage, image } = pricedCataloguedProduct || {}
  const { t } = useTranslation()
  const { formatMoney } = useMoney()

  return (
    <section data-testid="product-preview">
      <div className="flex justify-between gap-x-2 rounded-md border bg-white p-4 text-sm">
        <div className="flex gap-x-3">
          <ImageItem
            src={image || productImage}
            alt={`${brand} ${itemDescription}`}
            className="size-24 flex-none border"
          />
          <div className="flex flex-col justify-center">
            <ProductItem product={product} />
            <p className="text-xs">
              {category && `${category?.parent?.name ? `${category?.parent?.name} > ` : ''}${category?.name}`}
            </p>
          </div>
        </div>
        {pricedCataloguedProduct && (
          <div className="flex flex-col justify-center">
            <p className="text-right text-base font-bold">{formatMoney({ amount: sellUnitPrice })}</p>
            <p className="text-right text-xs text-gray-500">
              {t('general.plusTax', 'Plus {{ taxPercentage }}% Tax', {
                taxPercentage: sellUnitTaxPercentage,
              })}
            </p>
          </div>
        )}
      </div>
    </section>
  )
}
